import moment from 'moment'

import type { FirstStepsSection } from 'modules/onboarding/lib/firstSteps/types'

// DO NOT ADD NEW CONSTANTS HERE.
// Use `i18nDateToString` instead, which uses translateable formats.
// Check the `modules/core/lib/dates.ts` file for the list of formats.
export const BACKEND_DATE_FORMAT = 'YYYY-MM-DD' // eslint-disable-line
export const BACKEND_DATETIME_FORMAT = moment.ISO_8601

export const TARGET_MARKETS = ['es']

export const defaultFont = 'Open+Sans'

export const defaultChargebeeLocale = 'en'

export const supportedChargebeeLocales = [defaultChargebeeLocale, 'es', 'fr', 'de', 'it', 'pt']

export const DAY_TYPES = {
  half_day: 'half_day',
  one_day: 'one_day',
  days: 'days',
  hours: 'hours',
}

export const appUrl: string = document.location.origin

export const publicSiteLocation: string = appUrl.replace(/app(-|\.)/, '')

export const days = () =>
  moment
    .localeData('en')
    .weekdays()
    .map((day) => day.toLowerCase())

export const LOCAL_STORAGE_KEYS = {
  allVariablesFilters: 'factorial:allvariablesFilters',
  atsApplicationsFilters: 'factorial:atsApplicationsFilters',
  atsCandidatesDefaultGrouping: 'factorial:atsCandidatesDefaultGrouping',
  atsCandidatesFilters: 'factorial:atsCandidatesFilters',
  atsCandidatesGroupingMode: 'factorial:atsCandidatesGroupingMode',
  atsHiringToolLegalDisclaimerAccepted: 'factorial:atsHiringToolLegalDisclaimerAccepted',
  atsInsightsFilters: 'factorial:atsInsightsFilters',
  atsJobApplicationsDefaultGrouping: 'factorial:atsJobApplicationsDefaultGrouping',
  atsJobApplicationsFilters: 'factorial:atsJobApplicationsFilters',
  atsJobApplicationsGroupingMode: 'factorial:atsJobApplicationsGroupingMode',
  atsMessagesConversationsFilters: 'factorial:atsMessagesConversationsFilters',
  atsMessageTemplatesFilters: 'factorial:atsMessageTemplatesFilters',
  atsNewApplicationFeedbackDraft: 'factorial:atsNewApplicationFeedbackDraft',
  atsNewCandidateFeedbackDraft: 'factorial:atsNewCandidateFeedbackDraft',
  atsNewMessageDraft: 'factorial:atsNewMessageDraft',
  atsNewMessageRememberConfirmation: 'factorial:atsNewMessageRememberConfirmation',
  autocompleteBillingInfo: 'factorial:autocompleteBillingInfo',
  bulkImportSupplementFilter: 'factorial:bulkImportSupplementFilter',
  calendarFilter: 'factorial:calendarFilter',
  calendarFilters: 'factorial:calendarFilters',
  cardsFilters: 'factorial:cardsFilters',
  costCentersDefaultGrouping: 'factorial:costCentersDefaultGrouping',
  costCentersGroupingMode: 'factorial:costCentersGroupingMode',
  discoverabilityWidgetData: 'factorial:discoverabilityWidgetData',
  employeeCostsDefaultGrouping: 'factorial:employeeCostsDefaultGrouping',
  employeeCostsGroupingMode: 'factorial:employeeCostsGroupingMode',
  employeeDocuments: 'factorial:employeeDocuments',
  employeesDefaultGrouping: 'factorial:employeesDefaultGrouping',
  employeeSelectorFilters: 'factorial:employeeSelectorFilters',
  employeesFilter: 'factorial:employeesFilter',
  employeesFilters: 'factorial:employeesFilters',
  employeesGroupingMode: 'factorial:employeesGroupingMode',
  expensesFilters: 'factorial:expensesFilters',
  expensesReportsFilters: 'factorial:expensesReportsFilters',
  expensesHasDismissedExpensesListCardsBanner:
    'factorial:expensesHasDismissedExpensesListCardsBanner',
  expensesHasDismissedSingleUseCardBanner: 'factorial:expensesHasDismissedSUCBanner',
  formsEmployeePulseLastSubmittedAt: 'factorial:formsEmployeePulseLastSubmittedAt',
  groupConditions: 'factorial:groupConditions',
  hideBecomeHint: 'factorial:hideBecomeHint',
  hideBreaksCalloutShiftManagement: 'factorial:hideBreaksCalloutShiftManagement',
  hideClockInCallout: 'factorial:hideClockInCallout',
  hideDocumentPayslipsDistributionHint: 'factorial:hideDocumentPayslipsDistributionHint',
  hideDocumentEsignaturePlacementHint: 'factorial:hideDocumentEsignaturePlacementHint',
  hideFinancialWorkspaceWelcome: 'factorial:hideFinancialWorkspaceWelcome',
  hideFinanceAccountsPayableUpsellModal: 'factorial:hideFinanceAccountsPayableUpsellModal',
  hideFinanceOverviewModuleUpsellBanner: 'factorial:hideFinanceOverviewModuleUpsellBanner',
  hideForgotClockOutWidget: 'factorial:hideForgotClockOutWidget',
  hideGoToFinanceWorkspaceTip: 'factorial:hideGoToFinanceWorkspaceTip',
  hidePayrollSettingsLaborCostHint: 'factorial:hidePayrollSettingsLaborCostHint',
  hideInsightsHintModalShiftManagement: 'factorial:hideInsightsHintModalShiftManagement',
  hidePayrollResultMapFileContentHint: 'factorial:hidePayrollResultMapFileContentHint',
  hidePayrollResultSetUpDataImportHint: 'factorial:hidePayrollResultSetUpDataImportHint',
  hideSplitShiftsCalloutShiftManagement: 'factorial:hideSplitShiftsCalloutShiftManagement',
  hideTimeCategoriesBetaTestersBanner: 'factorial:hideTimeCategoriesBetaTestersBanner',
  hideMissingClockInInconsistencyBanner: 'factorial:hideMissingClockInInconsistencyBanner',
  hideTakeBreakReminderModal: 'factorial:hideTakeBreakReminderModal',
  hideBankOfHoursCallout: 'factorial:hideBankOfHoursCallout',
  hideTimeTrackingRealTimeBanner: 'factorial:hideTimeTrackingRealTimeBanner',
  hideTrialEmployeesHint: 'factorial:hideTrialEmployeesHint',
  hideExtraHoursNote: 'factorial:hideExtraHoursNote',
  hideTimeOffConditionsCallout: 'factorial:hideTimeOffConditionsCallout',
  integrationsJoinHideStandarBoardCallout: 'factorial:integrationsJoinHideStandarBoardCallout',
  jobPostingJoinDeprecationBanner: 'factorial:jobPostingJoinDeprecationBanner',
  integrationsJoinHideJobMultipostingErrorCallout:
    'factorial:integrationsJoinHideJobMultipostingErrorCallout',
  jobApplicationsDefaultGrouping: 'factorial:jobApplicationsDefaultGrouping',
  jobApplicationsFilters: 'factorial:jobApplicationsFilters',
  jobApplicationsGroupingMode: 'factorial:jobApplicationsGroupingMode',
  jobCatalogEmployeesFilter: 'factorial:jobCatalogEmployeesFilter',
  jobCatalogRolesFilter: 'factorial:jobCatalogRolesFilter',
  jobsDefaultGrouping: 'factorial:jobsDefaultGrouping',
  jobsFilters: 'factorial:jobsFilters',
  jobsTableFilters: 'factorial:jobsTableFilters',
  jobsGroupingMode: 'factorial:jobsGroupingMode',
  lastVisitedEmployeeId: 'factorial:lastVisitedEmployeeId',
  observationFilters: 'factorial:observationFilters',
  onboardingMeetingData: 'factorial:onboardingMeetingData',
  orderEmployeesShiftManagementBy: 'factorial:orderEmployeesShiftManagementBy',
  orderEmployeesShiftManagementDir: 'factorial:orderEmployeesShiftManagementDir',
  orgChart: 'factorial:orgChart',
  payrollIssues: 'factorial:payrollIssues',
  payrollPaymentsFilters: 'factorial:payrollPaymentsFilters',
  payrollResultsConceptsFilters: 'factorial:payrollResultsConceptsFilters',
  payrollResultsFilters: 'factorial:payrollResultsFilters',
  payrollResultsTableColumnConfig: 'factorial:payrollResultsTableColumnConfig',
  payrollSalaryCardInfoRequested: 'factorial:salaryCard:infoRequested',
  performanceProcessEnterpriseUpsellingBannerShow:
    'factorial:performanceProcessEnterpriseUpsellingBannerShow',
  performanceProcessShowFilters: 'factorial:performanceProcessShowFilters',
  performanceReviewIds: 'factorial:performanceReviewIds',
  performanceCyclesCycleFilter: 'factorial:performanceCyclesCycleFilter',
  preSelectedLeaveTypeIds: 'factorial:preSelectedLeaveTypeIds',
  preSelectedManagerId: 'factorial:preSelectedManagerId',
  preSelectedTemplateType: 'factorial:preSelectedTemplateType',
  processesUploadDocumentBannerClosed: 'factorial:processesUploadDocumentBannerClosed',
  projectsNotShowWarningModal: 'factorial:projectsNotShowWarningModal',
  shiftEmployees: 'factorial:shiftEmployees',
  shiftManagementAllViewOptions: 'factorial:shiftManagementAllViewOptions',
  shiftManagementConvertHoursInsights: 'factorial:shiftManagementConvertHoursInsights',
  shiftManagementFilter: 'factorial:shiftManagementFilter',
  shiftManagementHideAddBreaksCallout: 'factorial:shiftManagementHideAddBreaksCallout',
  shiftManagementHideInsightsQuickTip: 'factorial:shiftManagementHideInsightsQuickTip',
  shiftManagementHideInsightsMaxYearlyHours: 'factorial:shiftManagementHideInsightsMaxYearlyHours',
  shiftManagementHideInsightsFeedbackRequest:
    'factorial:shiftManagementHideInsightsFeedbackRequest',
  shiftManagementHideNewHoursToPlanPopover: 'factorial:shiftManagementHideNewHoursToPlanPopover',
  shiftManagementHidePublishShiftInfo: 'factorial:shiftManagementHidePublishShiftInfo',
  shiftManagementHideSaveNewShiftInfo: 'factorial:shiftManagementSaveNewShiftInfo',
  shiftManagementHideSaveShiftToggle: 'factorial:shiftManagementHideSaveShiftToggle',
  shiftManagementInsightsLocationSelection: 'factorial:shiftManagementInsightsLocationSelection',
  shiftManagementInsightsTeamSelection: 'factorial:shiftManagementInsightsTeamSelection',
  shiftManagementView: 'factorial:shiftManagementView',
  showPayrollPromoHint: 'factorial:showPayrollPromoHint',
  showProductUpdatesBanner: 'factorial:showProductUpdatesBanner',
  showTimezoneMessage: 'showTimezoneMessage',
  signedInvoicesFiltersClosed: 'factorial:signedInvoicesFiltersClosed',
  signedInvoicesFiltersNotReady: 'factorial:signedInvoicesFiltersNotReady',
  signedInvoicesFiltersReady: 'factorial:signedInvoicesFiltersReady',
  softwareEmployeesDefaultGrouping: 'factorial:softwareEmployeesDefaultGrouping',
  softwareEmployeeSelector: 'factorial:softwareEmployeeSelector',
  softwareEmployeesFilters: 'factorial:softwareEmployeesFilters',
  softwareEmployeesGrouping: 'factorial:softwareEmployeesGrouping',
  softwareTerminatedEmployeesFilters: 'factorial:softwareTerminatedEmployeesFilters',
  supplementFilters: 'factorial:supplementFilters',
  talentPoolDefaultGrouping: 'factorial:talentPoolDefaultGrouping',
  talentPoolFilters: 'factorial:talentPoolFilters',
  talentPoolGroupingMode: 'factorial:talentPoolGroupingMode',
  tasksStatusFilter: 'factorial:tasksStatusFilter',
  tasksStateFilter: 'factorial:tasksStateFilter',
  timeBalanceCycle: 'factorial:timeBalanceCycle',
  timeTrackingFilters: 'factorial:timeTrackingFilters',
  timeTrackingViewType: 'factorial:timeTrackingViewType',
  transactionsFilters: 'factorial:transactionsFilters',
  upsellMeetingData: 'factorial:upsellMeetingData',
  visitorToken: 'factorial:hsVisitorToken',
  workspaceSelectedPayrollConcepts: 'factorial:WorkspaceSelectedConcepts',
  budgetsDiscoverabilityWidgetSeen: 'factorial:budgetsDiscoverabilityWidgetSeen',
  employeesImporterSubmittedCalloutSeen: 'factorial:employeesImporterCalloutSeen',
  employeesImporterFinishedCalloutSeen: 'factorial:employeesImporterFinishedCalloutSeen',
  showRecruitmentBanner: 'factorial:showRecruitmentBanner',
  showExpensesBanner: 'factorial:showExpensesBanner',
  myProjectsFilters: 'factorial:myProjectsFilters',
  hidePerformanceProcessScoreRangeCallout: 'factorial:hidePerformanceProcessScoreRangeCallout',
  hidePerformanceProcessMissingCompetenciesCallout:
    'factorial:hidePerformanceProcessMissingCompetenciesCallout',
  yourYearInFactsCurrentStep: 'factorial:yourYearInFactsCurrentStep',
  seeDiscoverModuleModal: 'factorial:seeDiscoverModuleModal',
  hidePerformanceProcessSectionsWeightsErrorCallout:
    'factorial:hidePerformanceProcessSectionsWeightsErrorCallout',
  viewUpsellProductCardComponent: 'factorial:viewUpsellProductCardComponent',
  upsellingKitDismissalState: (component: string, requestSource: string) =>
    `factorial:upsellingKitDismissalState:${component}:${requestSource}`,
  inAppCommsDismissedIds: 'factorial:inAppCommsDismissedIds',
  meetingSoundsEnabled: 'factorial:meetingSoundsEnabled',
  meetingVirtualBackgroundEnabled: 'factorial:meetingVirtualBackgroundEnabled',
  meetingChatHistory: (meetingId: string) => `factorial:meetingChatHistory:${meetingId}`,
  meetingLiveCompanion: `factorial:meetingLiveCompanion`,
}

export const LOCAL_STORAGE_KEYS_FACTORIAL_TIPS = {
  hideGrossSalaryTip: 'factorial:hideGrossSalaryTip',
  hideAdditionalCompensationsTip: 'factorial:hideAdditionalCompensationsTip',
  hideContractCustomFieldsTip: 'factorial:hideContractCustomFieldsTip',
  hideContractCustomFieldsInSettingsTip: 'factorial:hideContractCustomFieldsInSettingsTip',
  hideOrgChartPositionsTip: 'factorial:hideOrgChartPositionsTip',
  hideAtsCallFromMyPhoneTip: 'factorial:hideAtsCallFromMyPhone',
  hideRoleCompetenciesSuggestionsTip: 'factorial:hideRoleCompetenciesSuggestionsTip',
  hideAtsDiscIntegrationTip: 'factorial:hideAtsDiscIntegrationTip',
  hideCompetenciesDiscoveryModalTip: 'factorial:hideCompetenciesDiscoveryModalTip',
  hideCustomNotificationChangeTip: 'factorial:hideCustomNotificationChangeTip',
  hideFinanceSettingsCostCentersTip: 'factorial:hideFinanceSettingsCostCentersTip',
  hideFinanceWorkspaceOnboardingHints: 'factorial:hideFinanceWorkspaceOnboardingHints',
  hideMyProjectsEmployeeHint: 'factorial:hideMyProjectsEmployeeHint',
  hideMyProjectsAdminHint: 'factorial:hideMyProjectsAdminHint',
  hideMyProjectsWithoutProjectsHint: 'factorial:hideMyProjectsWithoutProjectsHint',
  hideMyProjectsWithProjectsHint: 'factorial:hideMyProjectsWithProjectsHint',
  hideScheduleMyProjectsHint: 'factorial:hideScheduleMyProjectsHint',
  hideDelegateApproverHint: 'factorial:hideDelegateApproverHint',
  hideMultiLocationHintAttendanceSetting: 'factorial:hideMultiLocationHintAttendanceSetting',
  WorkedDefinitionBanner: 'factorial:hideWorkedDefinitionBanner',
  hideWorkflowsActionsPromotionHint: 'factorial:hideWorkflowsActionsPromotionHint',
  hidePerformanceProcessManagerFilterHint: 'factorial:hidePerformanceProcessManagerFilterHint',
  hideTeamChartActivationBanner: 'factorial:hideTeamChartActivationBanner',
  hideActivityLogHint: 'factorial:hideActivityLogHint',
  hideTasksTabHint: 'factorial:hideTasksTabHint',
  hideEditInBulkPermissionsHint: 'factorial:hideEditInBulkPermissionsHint',
  hideProjectsUpsellTaskModal: 'factorial:hideProjectsUpsellTaskModal',
  hideProjectsConfigLaborCostModal: 'factorial:hideProjectsConfigLaborCostModal',
  hideProjectsAnnouncementKanbanTasksModal: 'factorial:hideProjectsAnnouncementKanbanTasksModal',
  hideProjectsUpsellModal: 'factorial:hideProjectsUpsellModal',
  hideProjectsUpsellClientsModal: 'factorial:hideProjectsUpsellClientsModal',
  hideTrainingDiscoveryModalTip: 'factorial:hideTrainingDiscoveryModalTip',
  hideExpensesReportLaunchBanner: 'factorial:hideExpensesReportLaunchBanner',
  hideContributorsScheduleBetaBanner: 'factorial:hideContributorsScheduleBetaBanner',
  hideProjectsKanbanViewHint: 'factorial:hideProjectsKanbanViewHint',
  hideProjectsTaskDetailsHint: 'factorial:hideProjectsTaskDetailsHint',
  hideScheduleOnboardingHint: 'factorial:hideScheduleOnboardingHint',
  hideProjectsScheduleModal: 'factorial:hideScheduleModal',
}

export const LOCAL_STORAGE_KEYS_FIRST_STEPS_VIDEO: Record<FirstStepsSection, string> = {
  time_tracking: 'factorial:hideFirstStepsTimeTracking',
  time_off: 'factorial:hideFirstStepTimeOff',
  shift_management: 'factorial:hideFirstStepsShiftManagement',
  recruitment: 'factorial:hideFirstStepsRecruitment',
  performance: 'factorial:hideFirstStepsPerformance',
  documents: 'factorial:hideFirstStepsDocuments',
  signature: 'factorial:hideFirstStepsSignature',
  expenses: 'factorial:hideFirstStepsExpenses',
  engagement: 'factorial:hideFirstStepsEngagement',
  payroll: 'factorial:hideFirstStepsPayroll',
}

export const MAX_ESIGNATURE_BULK_CREATE = 40

export const timeFormats = [24, 12]

// Supported timezones. We are using the same timezones as in BE, which relies in
// ActiveSupport. But AS itself doesn't have all the timezones that we need, so
// if the validation relied just on those, we would face several issues in
// different flows, e.g. signup
// For that reason, we combine this original list with the non-common timezones
// provided by TZInfo::Country.all
// Despite ActiveSupport includes GMT+12 in their mapping, we manually removed it
export const supportedTimezones = [
  'Pacific/Midway',
  'Pacific/Pago_Pago',
  'Pacific/Honolulu',
  'America/Juneau',
  'America/Los_Angeles',
  'America/Tijuana',
  'America/Denver',
  'America/Phoenix',
  'America/Chihuahua',
  'America/Mazatlan',
  'America/Chicago',
  'America/Regina',
  'America/Mexico_City',
  'America/Monterrey',
  'America/Guatemala',
  'America/New_York',
  'America/Indiana/Indianapolis',
  'America/Bogota',
  'America/Lima',
  'America/Halifax',
  'America/Caracas',
  'America/La_Paz',
  'America/Santiago',
  'America/St_Johns',
  'America/Sao_Paulo',
  'America/Argentina/Buenos_Aires',
  'America/Montevideo',
  'America/Guyana',
  'America/Puerto_Rico',
  'America/Godthab',
  'Atlantic/South_Georgia',
  'Atlantic/Azores',
  'Atlantic/Cape_Verde',
  'Europe/Dublin',
  'Europe/London',
  'Europe/Lisbon',
  'Africa/Casablanca',
  'Africa/Monrovia',
  'Etc/UTC',
  'Europe/Belgrade',
  'Europe/Bratislava',
  'Europe/Budapest',
  'Europe/Ljubljana',
  'Europe/Prague',
  'Europe/Sarajevo',
  'Europe/Skopje',
  'Europe/Warsaw',
  'Europe/Zagreb',
  'Europe/Brussels',
  'Europe/Copenhagen',
  'Europe/Madrid',
  'Europe/Paris',
  'Europe/Amsterdam',
  'Europe/Berlin',
  'Europe/Zurich',
  'Europe/Rome',
  'Europe/Stockholm',
  'Europe/Vienna',
  'Africa/Algiers',
  'Europe/Bucharest',
  'Africa/Cairo',
  'Europe/Helsinki',
  'Europe/Kiev',
  'Europe/Riga',
  'Europe/Sofia',
  'Europe/Tallinn',
  'Europe/Vilnius',
  'Europe/Athens',
  'Europe/Istanbul',
  'Europe/Minsk',
  'Asia/Jerusalem',
  'Africa/Harare',
  'Africa/Johannesburg',
  'Europe/Kaliningrad',
  'Europe/Moscow',
  'Europe/Volgograd',
  'Europe/Samara',
  'Asia/Kuwait',
  'Asia/Riyadh',
  'Africa/Nairobi',
  'Asia/Baghdad',
  'Asia/Tehran',
  'Asia/Muscat',
  'Asia/Baku',
  'Asia/Tbilisi',
  'Asia/Yerevan',
  'Asia/Kabul',
  'Asia/Yekaterinburg',
  'Asia/Karachi',
  'Asia/Tashkent',
  'Asia/Kolkata',
  'Asia/Kathmandu',
  'Asia/Dhaka',
  'Asia/Colombo',
  'Asia/Almaty',
  'Asia/Novosibirsk',
  'Asia/Rangoon',
  'Asia/Bangkok',
  'Asia/Jakarta',
  'Asia/Krasnoyarsk',
  'Asia/Shanghai',
  'Asia/Chongqing',
  'Asia/Hong_Kong',
  'Asia/Urumqi',
  'Asia/Kuala_Lumpur',
  'Asia/Singapore',
  'Asia/Taipei',
  'Australia/Perth',
  'Asia/Irkutsk',
  'Asia/Ulaanbaatar',
  'Asia/Seoul',
  'Asia/Tokyo',
  'Asia/Yakutsk',
  'Australia/Darwin',
  'Australia/Adelaide',
  'Australia/Melbourne',
  'Australia/Sydney',
  'Australia/Brisbane',
  'Australia/Hobart',
  'Asia/Vladivostok',
  'Pacific/Guam',
  'Pacific/Port_Moresby',
  'Asia/Magadan',
  'Asia/Srednekolymsk',
  'Pacific/Guadalcanal',
  'Pacific/Noumea',
  'Pacific/Fiji',
  'Asia/Kamchatka',
  'Pacific/Majuro',
  'Pacific/Auckland',
  'Pacific/Tongatapu',
  'Pacific/Fakaofo',
  'Pacific/Chatham',
  'Pacific/Apia',
  'Europe/Andorra',
  'Asia/Dubai',
  'Europe/Tirane',
  'Africa/Lagos',
  'America/Barbados',
  'Africa/Abidjan',
  'Asia/Qatar',
  'Africa/Maputo',
  'Atlantic/Bermuda',
  'Asia/Brunei',
  'America/Toronto',
  'Asia/Thimphu',
  'America/Belize',
  'Indian/Cocos',
  'Pacific/Rarotonga',
  'America/Costa_Rica',
  'America/Havana',
  'Indian/Christmas',
  'America/Santo_Domingo',
  'Africa/El_Aaiun',
  'Atlantic/Stanley',
  'Atlantic/Faroe',
  'America/Cayenne',
  'Europe/Gibraltar',
  'Africa/Bissau',
  'America/Tegucigalpa',
  'America/Port-au-Prince',
  'Indian/Chagos',
  'Atlantic/Reykjavik',
  'America/Jamaica',
  'Asia/Amman',
  'Asia/Bishkek',
  'Asia/Pyongyang',
  'America/Panama',
  'Asia/Beirut',
  'Europe/Luxembourg',
  'Africa/Tripoli',
  'Europe/Monaco',
  'Europe/Chisinau',
  'Asia/Yangon',
  'Asia/Macau',
  'America/Martinique',
  'Europe/Malta',
  'Indian/Mauritius',
  'Indian/Maldives',
  'Africa/Windhoek',
  'Pacific/Norfolk',
  'America/Managua',
  'Europe/Oslo',
  'Pacific/Nauru',
  'Pacific/Niue',
  'Asia/Manila',
  'America/Miquelon',
  'Pacific/Pitcairn',
  'Pacific/Palau',
  'America/Asuncion',
  'Indian/Reunion',
  'Indian/Mahe',
  'Africa/Khartoum',
  'America/Paramaribo',
  'Africa/Juba',
  'Africa/Sao_Tome',
  'America/El_Salvador',
  'Asia/Damascus',
  'America/Grand_Turk',
  'Africa/Ndjamena',
  'Asia/Dushanbe',
  'Asia/Dili',
  'Asia/Ashgabat',
  'Africa/Tunis',
  'Pacific/Funafuti',
  'Pacific/Efate',
  'Pacific/Wallis',
]
